<template>

    <v-app id="inspire">
        <div v-if="error">
            <app-message :rang="rang"  :matn="error_message" ></app-message>
        </div>
        <div v-if="currency">
            <app-currency v-on:qurb_change="mounting"/>
        </div>

        <ModalIdle v-if="isIdle" />

        <v-dialog
        v-model="logout_dialog"
        max-width="350"
      >
        <v-card>
          <v-card-title class="text-h5">
            Выход из системы
          </v-card-title>

          <v-card-text>
            Вы действительно хотите выйти из системы?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              text
              @click="logout_dialog = false"
            >
              Отмена
            </v-btn>

            <v-btn
              color="error darken-1"
              text
              @click="logout"
            >
              ДА
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>



  <v-row v-if="dialog" justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="30%"
    >

      <v-card>
      <v-form @submit.prevent="newPassword"
                    ref="form"
                    v-model="valid"
                    lazy-validation
                >
        <v-card-title class="text-h5">
          Вам небходимо ввести новый пароль
        </v-card-title>
        <v-card-text>
        <v-text-field
            v-model="form.password"
            autofocus
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="passwordRules"
            :type="show1 ? 'text' : 'password'"
            name="input-10-1"
            label="Введите новый пароль для вход в систему"
            hint="Введите новый пароль для вход в систему"
            counter
            @click:append="show1 = !show1"
          ></v-text-field>
          </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            type="submit"
            :disabled="!valid"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>

  <div v-if="onLine==false">
  <v-dialog
    v-model="dialog_internet"
      max-width="290"
      persistent
    >
            <v-alert
                type="error"
                border="left"
                elevation="2"
                colored-border
                >
                Проверьте подключение к интернету
            </v-alert>
    </v-dialog>
</div>



      <v-app-bar
        app
        color="white"
        flat
      >

          <v-tabs

      v-model="tab"
      background-color="#2196F3"
      centered
      dark
      icons-and-text
    >
      <v-tabs-slider></v-tabs-slider>
      <vue-internet-checker
      @status="status"
      @event="event"
      />




      <v-spacer></v-spacer>
      <v-tab  @click="go_to_home">
        Главная
        <v-icon>mdi-home</v-icon>
      </v-tab>

      <v-tab  to="/kharid">
        Покупка
        <v-icon>mdi-cart-arrow-down</v-icon>
      </v-tab>



      <v-tab to="/tovari">
        Товары
        <v-icon>mdi-shopping-outline</v-icon>
      </v-tab>
      <v-tab to="/moving">
        Перемещение
        <v-icon>mdi-swap-horizontal</v-icon>
      </v-tab>

      <v-tab @click="go_to_kassa" >
        Касса
        <v-icon>mdi-cash-register</v-icon>
      </v-tab>

      <v-tab    @click="go_to_priyom">
        Приём смена
        <v-icon>mdi-lock-clock</v-icon>
      </v-tab>

      <v-tab  @click="go_to_reports">
        Отчеты
        <v-icon>mdi-chart-timeline-variant-shimmer</v-icon>
      </v-tab>

      <v-tab @click="go_to_setting">
        Настройки
        <v-icon>mdi-cog</v-icon>
      </v-tab>


        <v-tab @click="go_to_spravochnik"  >
        Справочник
        <v-icon>mdi-book-open-page-variant</v-icon>
        </v-tab>

        <v-tab @click="logout_dialog = true">
            Выход
            <v-icon>mdi-logout</v-icon>
            </v-tab>



        <v-spacer></v-spacer>


            <v-menu offset-y v-if="notification">
              <template v-slot:activator="{ on, attrs }">
                <v-icon  v-bind="attrs"
                v-on="on"  class="mr-3"  style="color:red; ">mdi-bell-badge</v-icon>

              </template>
              <v-list v-for="(item, index) in items"
              :key="index">
                <v-list-item
                  link
                  :to="item.link"
                >
                {{ item.title }}
                </v-list-item>
              </v-list>
            </v-menu>



        <!-- <v-icon v-if="notification" class="mr-3"  style="color:red; ">mdi-bell-badge</v-icon> -->



        <v-icon v-if="onLine==true" class="mr-3"  style="color:lime; ">mdi-wifi-arrow-up-down</v-icon>
        <v-icon v-if="onLine==false" class="mr-3"  style="color:red; ">mdi-wifi-off</v-icon>




    </v-tabs>



      </v-app-bar>


      <v-dialog
      v-model="password_dialog"
      max-width="320"
    >
      <v-card>
        <v-card-title class="text">
          У вас нет доступа к данной странице
        </v-card-title>

        <v-card-text>
            <v-text-field
            v-model="parol"
            label="Введите хеш суперадмина"
            name="input-10-1"
            type="password"
            autofocus

           @keydown.enter="checkPassword"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="error darken-1"
            text
            @click="password_dialog = false"
          >
            Отмена
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="checkPassword"
            :disabled="parol =='' || parol ==null "
          >
            ОК
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


      <v-main
       class="grey lighten-3 ">
        <keep-alive >
            <router-view ></router-view>
        </keep-alive>
      </v-main>
    </v-app>
  </template>



<script>

import Home from '../views/Home'
import vueInternetChecker from 'vue-internet-checker';


export default {


    data() {
        return {
            logout_dialog:false,

            dialog_internet: true,
            onLine: true,
            currency: true,
            tab: null,
            error: false,
            error_message: '',
            rang: '#D50000',

            valid: false,
            dialog: false,
            show1: false,
            form:{
                password: ''
            } ,

            password_dialog: false,
            parol: "",
            notification: false,

            items: [

            ],



       passwordRules: [
        v => !!v || 'Введите новый пароль',
        v => (v && v.length >= 3) || 'Пароль должен быть не менее 3 символов',
        v=> (v && /[0-9]/.test(v)) || 'Пароль должен содержать минимум одну цифру',
      ],

      dostup:"",
      hash:"",
      accept: false,

      noti_data:{
        srok:"",
        minimum:"",
        minus:"",
      },






        }
    },


    components: {

        Home,
        vueInternetChecker,




},
computed:{
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },


},
mounted() {

    this.openDialog();

    this.$session.start();
    this.dostup = this.$session.get("dostup");
    this.hash = this.$session.get("hash");

    if(this.dostup==1){
        this.$router.push({name: 'home'});
    }else{
        this.$router.push({name: 'tovari'});
    }



   this.get_notification();



},
watch: {
    isIdle: function () {
     // if (this.isIdle) alert("a felhasználó inaktív");
    },
  },

  methods: {


    get_notification(){




        this.get_srok();
        this.get_minus_tovar();
        this.get_noti_minimum();


    },



    get_srok(){

        axios.get('/api/get_noti_srok',
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){

                               this.items.push({ title: response.data.message, link: '/reports' });
                                this.notification = true;
                                setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }else{
                                    this.loading = false;

                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }
                            })
                            .catch(error => {

                                this.loading = false;

                            });

    },


    get_minus_tovar(){

        axios.get('/api/get_minus_tovar',
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){
                                // this.vozvratho = response.data.kharid
                                // this.loading = false;
                                this.noti_data.minus = response.data.message;
                               this.items.push({ title: response.data.message,  link: '/tovari'  });
                                this.notification = true;
                                setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }else{
                                    this.loading = false;

                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }
                            })
                            .catch(error => {

                                this.loading = false;

                            });

        },

        get_noti_minimum(){

axios.get('/api/get_noti_minimum',
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){

                       this.items.push({ title: response.data.message,  link: '/reports'  });
                        this.notification = true;
                        setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }else{
                            this.loading = false;

                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {

                        this.loading = false;

                    });

},


    go_to_spravochnik(){


        if(this.dostup ==1 || this.dostup =="1"|| this.accept == true){
            this.$router.push({name: 'spravochniki'});
        }else{
            this.password_dialog = true;
        }

    },

    go_to_setting(){
        if(this.dostup ==1 || this.dostup =="1"|| this.accept == true){
            this.$router.push({name: 'settings'});
        }else{
            this.password_dialog = true;
        }

        //to="/settings"
    },

    go_to_priyom(){
        //to="/reports"
        if(this.dostup ==1 || this.dostup =="1"|| this.accept == true){
            this.$router.push({name: 'priyom'});
        }else{
            this.password_dialog = true;
        }
    },

    go_to_reports(){
        //to="/reports"
        if(this.dostup ==1 || this.dostup =="1"|| this.accept == true){
            this.$router.push({name: 'reports'});
        }else{
            this.password_dialog = true;
        }
    },

    go_to_kassa(){
        //to="/reports"
        if(this.dostup ==1 || this.dostup =="1"|| this.accept == true){
            this.$router.push({name: 'kassa'});
        }else{
            this.password_dialog = true;
        }
    },
    go_to_home(){
        if(this.dostup ==1 || this.dostup =="1"|| this.accept == true){
            this.$router.push({name: 'home'});
        }else{
            this.password_dialog = true;
        }
    },


    checkPassword(){
        var md5 = require('md5');


        if(this.parol == null || this.parol ==""){
            this.error = true
            this.error_message = "Введите пароль!"
            this.accept = false;
            setTimeout(() => {
            this.error = false;
            }, 2000);

        }else{
            var md5_ed = md5(md5(md5(this.parol)));
            if(md5_ed==this.hash){

                this.accept = true;
                this.password_dialog = false
                this.error = true
                this.error_message = "Доступ открыто"
                this.rang = "success"
                setTimeout(() => {
                this.error = false;
                }, 2000);

            }else{
                this.error = true
            this.error_message = "Пароль неверный!"
            this.accept = false;
            setTimeout(() => {
            this.error = false;
            }, 2000);
            }
        }



    },
    mounting(){

        this.currency = false;

    },

    logout(){
        this.$session.destroy();
           this.$router.push('/auth');

    },

    openDialog() {
        this.$session.start();
        if(this.$session.get('boyad_ivaz')=='2'){
            this.dialog = true;

        }else{
            this.dialog = false;
        }

    },



    newPassword(){

        axios.post('/api/newPassword/'+(this.$session.get('id_user')), this.form, {
                headers: {
                    "Content-type": "application/json"
                }
            })

                .then(response => {
                    if(response.data.status){

                        this.$session.set('boyad_ivaz', '1');
                        this.dialog = false;
                    }else{
                         this.loading  = false;
                        this.error = true;
                        this.error_message = "Ошибка авторизации";
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading  = false;
                    this.error = true;
                    this.error_message = error.response.data.message;
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                });



    },

        status(ele) {
            console.log(ele);
            this.onLine = ele;
            },
        event(ele) {
            console.log(ele);

        },

  },

}
</script>

<style >


</style>
